import { parseListDate } from "helpers/parseListDate";
import { InvoiceListData } from "./InvoicesList.types";

/**
 * Formats an invoice row by parsing date fields
 * @param row - The invoice row data
 * @returns Formatted invoice row with parsed dates
 */
export const formatInvoiceRow = (
  row: InvoiceListData
): { [K in keyof typeof row]: React.ReactNode } => {
  let formattedRow: any = { ...row };

  if (formattedRow.invoices__AddDate) {
    formattedRow = {
      ...formattedRow,
      invoices__AddDate: parseListDate(formattedRow.invoices__AddDate, true),
    };
  }
  if (formattedRow.invoices__EditDate) {
    formattedRow = {
      ...formattedRow,
      invoices__EditDate: parseListDate(formattedRow.invoices__EditDate, true),
    };
  }

  if (formattedRow.invoices__InvoiceDate) {
    formattedRow = {
      ...formattedRow,
      invoices__InvoiceDate: parseListDate(formattedRow.invoices__InvoiceDate, true),
    };
  }

  if (formattedRow.invoices__InvoiceReceivedDate) {
    formattedRow = {
      ...formattedRow,
      invoices__InvoiceReceivedDate: parseListDate(
        formattedRow.invoices__InvoiceReceivedDate,
        true
      ),
    };
  }

  return formattedRow;
};
